namespace RedBullMOBILE360.AutomaticReports {
    export interface ReportLogForm {
        ReportId: Serenity.IntegerEditor;
        Recipients: Serenity.StringEditor;
        SendingDate: Serenity.DateEditor;
        Status: Serenity.IntegerEditor;
    }

    export class ReportLogForm extends Serenity.PrefixedContext {
        static formKey = 'AutomaticReports.ReportLog';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReportLogForm.init)  {
                ReportLogForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;

                Q.initFormType(ReportLogForm, [
                    'ReportId', w0,
                    'Recipients', w1,
                    'SendingDate', w2,
                    'Status', w0
                ]);
            }
        }
    }
}
